<p>month-end-snapshot works!</p>
